'use strict';

var MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June', 'July',
  'August', 'September', 'October', 'November', 'December'
];

function formatDate(date) {
  if (typeof date === 'string') {
    date = new Date(date);
  }

  return MONTHS[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
}

module.exports = formatDate;


/** WEBPACK FOOTER **
 ** ./utils/formatDate.js
 **/